import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { canUseDOM } from 'exenv';

import HowItWorksHeader from 'components/how-it-works/header';
import TextToDownload from 'components/common/text-to-download';
import BasicValueProps from 'components/common/value-props/basic-value-props';
import PeopleLoveParkWhiz from 'components/common/value-props/people-love-parkwhiz';
import HowItWorks from 'components/common/how-it-works';

import { PAGEVIEW_EVENT } from 'lib/analytics/events';
import * as AppContext from 'lib/app-context';
import { HOW_IT_WORKS_APP } from 'lib/app-names';
import { pageProps, urlProps } from 'lib/analytics/page-properties';

import Brand from 'models/brand';

import addMessageAndScrollToTop from 'action-creators/messaging/add-message-and-scroll-to-top';
import trackEventCreator from 'action-creators/analytics/track-event';
import sendAppDownloadTextCreator from 'action-creators/brand/send-app-download-text';
import cleanupHowItWorksState from 'action-creators/brand/cleanup-how-it-works-state';

const propTypes = {
  appContext: PropTypes.string,
  brand: PropTypes.instanceOf(Brand).isRequired,
  sendAppDownloadText: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
  cleanupHowItWorksState: PropTypes.func.isRequired,
};

const defaultProps = {
  appContext: AppContext.MOBILE,
};

class HowItWorksPage extends Component {
  componentWillMount() {
    if (canUseDOM) {
      const pageProperties = pageProps({ app: HOW_IT_WORKS_APP });
      this.props.trackEvent({
        ...PAGEVIEW_EVENT,
        ...pageProperties,
        name: pageProperties.pageName,
        properties: urlProps(),
      });
    }
  }

  componentWillUnmount() {
    this.props.cleanupHowItWorksState();
  }

  render() {
    const { appContext, sendAppDownloadText, brand } = this.props;
    return (
      <div className="how-it-works-page">
        <HowItWorksHeader brand={brand} />
        <div className="row bottom-shadow-blur">
          <HowItWorks appContext={appContext} brand={this.props.brand} />
        </div>
        <BasicValueProps
          className="margin-vertical-40"
        />
        <TextToDownload
          className="margin-vertical-80"
          sendAppDownloadText={sendAppDownloadText}
          brand={this.props.brand}
        />
        <PeopleLoveParkWhiz
          className="margin-vertical-40"
          brand={brand}
        />
      </div>
    );
  }
}

HowItWorksPage.propTypes = propTypes;
HowItWorksPage.defaultProps = defaultProps;

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    addMessageAndScrollToTop,
    trackEvent: trackEventCreator,
    sendAppDownloadText: sendAppDownloadTextCreator,
    cleanupHowItWorksState,
  }, dispatch)
);

const mapStateToProps = (state) => {
  const {
    appContext,
  } = state.app;

  const { brand } = state.brand;

  return {
    appContext,
    brand,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HowItWorksPage);
